import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconEventSeriesStyle0 = cosmosIconCss;

const CosmosIconEventSeries$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconEventSeries extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'a4e9d3d88228eb56997f8fa692f44c970b0ad3f4', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'ccdfa9dd88de430acadc438643eea8cd21c4cab4', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '4a874f1699e7e099e266d694bbf4938718fb2b3a', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M15.344 3.2h3.25c.224 0 .406.18.406.4v12c0 .22-.182.4-.406.4H6.406A.403.403 0 0 1 6 15.6v-12c0-.22.182-.4.406-.4h3.25v-.8c0-.22.182-.4.406-.4h.407c.224 0 .406.18.406.4v.8h3.25v-.8c0-.22.182-.4.406-.4h.406c.225 0 .407.18.407.4v.8ZM7.5 14.5h10v-10h-2.156v.8c0 .22-.182.4-.406.4h-.407a.403.403 0 0 1-.406-.4v-.8h-3.25v.8c0 .22-.182.4-.406.4h-.406a.403.403 0 0 1-.407-.4v-.8H7.5v10Z", fill: "currentColor" }), h("path", { key: '043b3c519a93ec99c662ba7e5a691395ebb611eb', d: "M4 6.75a.75.75 0 0 0-1.5 0V19a.5.5 0 0 0 .5.5h12.25a.75.75 0 0 0 0-1.5H4V6.75Z", fill: "currentColor" }), h("path", { key: '8556cfcfe607cf2e0b760623603e96ccdcdb0e2f', d: "M10.549 12.93a.374.374 0 0 1-.187.07c-.136 0-.183-.113-.129-.31l.627-2.163-1.716-1.513C9.039 8.924 9 8.862 9 8.784c0-.108.082-.159.284-.178l2.14-.195.864-2.185c.062-.16.125-.226.214-.226.09 0 .148.062.214.226l.864 2.185 2.136.194c.202.02.284.07.284.18 0 .077-.039.14-.144.229l-1.712 1.513.626 2.162c.059.194.012.311-.128.311a.386.386 0 0 1-.187-.07l-1.953-1.28-1.953 1.28Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconEventSeriesStyle0; }
}, [1, "cosmos-icon-event-series", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-event-series"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-event-series":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconEventSeries$1);
            }
            break;
    } });
}

const CosmosIconEventSeries = CosmosIconEventSeries$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconEventSeries, defineCustomElement };
